import { Input } from "@/components/ui/input";
import { money } from "@/lib/academyFormat";
import { ACADEMY } from "@/constants/testIds";

export const BILLS = ["100", "50", "20", "10", "5", "2", "1"];
export const emptyCount = () => ({ bills: Object.fromEntries(BILLS.map((b) => [b, ""])), coins: "" });
export const countTotal = (c) => BILLS.reduce((s, b) => s + Number(b) * (Number(c.bills[b]) || 0), 0) + (Number(c.coins) || 0);
export const countBody = (c) => ({
  bills: Object.fromEntries(BILLS.filter((b) => Number(c.bills[b]) > 0).map((b) => [b, Number(c.bills[b])])),
  coins: Number(c.coins) || 0,
});

// Fix V (2026-10-13): contar los billetes de la caja (cuantos de cada uno) y las monedas.
export default function BillCounter({ value, onChange }) {
  const setBill = (b, v) => onChange({ ...value, bills: { ...value.bills, [b]: v.replace(/\D/g, "") } });
  return (
    <div className="space-y-3" data-testid={ACADEMY.billCounter}>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {BILLS.map((b) => (
          <label key={b} className="flex items-center gap-2 rounded-lg border border-border bg-white px-3 py-2">
            <span className="text-sm font-medium w-12">${b}</span>
            <span className="text-muted-foreground text-xs">×</span>
            <Input inputMode="numeric" className="h-8" value={value.bills[b]} onChange={(e) => setBill(b, e.target.value)} placeholder="0" data-testid={`${ACADEMY.billInputPrefix}${b}`} />
          </label>
        ))}
        <label className="flex items-center gap-2 rounded-lg border border-border bg-white px-3 py-2">
          <span className="text-sm font-medium">Monedas</span>
          <Input type="number" min="0" step="0.01" className="h-8" value={value.coins} onChange={(e) => onChange({ ...value, coins: e.target.value })} placeholder="0.00" data-testid={ACADEMY.coinsInput} />
        </label>
      </div>
      <p className="text-sm">Total contado: <strong data-testid={ACADEMY.countTotal}>{money(countTotal(value))}</strong></p>
    </div>
  );
}
